/** biome-ignore-all lint/performance/noImgElement: DISABLED */
import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
	CarouselWithThumbnails,
} from "@components";
import { ChevronLeft } from "@untitledui/icons";
import AutoHeight from "embla-carousel-auto-height";
import { useState } from "react";
import { useChecklistStore } from "../store";
import { type DamageKeyType, DamageTypeLabel } from "../types";

export const SummaryImageDetailsCarousel = () => {
	const checklist = useChecklistStore((state) => state.checklist);
	const [showCarousel, setShowCarousel] = useState(false);

	const { summary } = checklist?.answerData || {};

	const carImages = summary?.lastSubmitted;

	return (
		<div className="w-full">
			{!!showCarousel && (
				<div className="relative">
					<CarouselWithThumbnails
						fixed
						options={carImages?.damageReportFiles || []}
					/>
					<button
						className="absolute top-5 left-4 z-20 rounded-full bg-black/50 p-2"
						onClick={() => setShowCarousel(false)}
						type="button"
					>
						<ChevronLeft className="text-gray-100" size={16} />
					</button>
				</div>
			)}

			<Carousel
				className="mx-auto w-full max-w-[800px] overflow-hidden"
				plugins={[AutoHeight()]}
			>
				<CarouselContent className="flex items-start duration-150">
					{carImages?.damageReportFiles?.map((item) => (
						<div
							className="min-w-0 max-w-full shrink-0 grow-0 basis-full"
							key={item.fileKey}
						>
							<CarouselItem>
								<button
									className="h-[284px] w-full max-w-[800px]"
									onClick={() => setShowCarousel(true)}
									type="button"
								>
									<img
										alt="car"
										className="h-full w-full object-cover"
										height={284}
										src={item.fileUrl}
										width={100}
									/>
								</button>
							</CarouselItem>

							<div className="mx-auto max-w-[456px]">
								<div className="mx-auto flex flex-col gap-2 p-4 pb-0">
									<h1 className="font-body font-semibold text-primary text-xl leading-normal">
										{item.description}
									</h1>

									<div className="flex flex-col gap-1">
										{!["Documento", "Painel ligar meia chave"].includes(
											item.description
										) && (
											<h4 className="font-body font-bold text-quaternary text-sm leading-5">
												Avarias
											</h4>
										)}

										<div className="flex flex-col gap-2">
											{Object.entries(item.damageSummary || {})?.map(
												([key, value]: [string, number]) => {
													const upperKey = key.toUpperCase() as DamageKeyType;

													return (
														<div className="flex justify-between" key={key}>
															<p className="font-body text-md text-secondary leading-normal">
																{DamageTypeLabel[upperKey]}
															</p>
															<p className="font-body text-md text-secondary leading-normal">
																{value}
															</p>
														</div>
													);
												}
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
				</CarouselContent>
				<CarouselPrevious className="top-[104px] left-6 translate-y-0 border-0" />
				<CarouselNext className="top-[104px] right-6 translate-y-0 border-0" />
			</Carousel>
		</div>
	);
};
